"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewApp = exports.TabSpinner = void 0;
var React = require("react");
var react_tabs_1 = require("react-tabs");
var components_1 = require("./components");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var simulationTab_1 = require("./simulationTab");
var typestyle_1 = require("typestyle");
var TabSpinner = function (props) {
    return (React.createElement("div", { className: "iconwrapper" },
        React.createElement("i", { className: (0, typestyle_1.classes)("fas fa-spinner fa-spin tabSpinner", props.className) })));
};
exports.TabSpinner = TabSpinner;
var OverviewApp = (function (_super) {
    __extends(OverviewApp, _super);
    function OverviewApp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tabIndex: 0,
            templates: []
        };
        return _this;
    }
    OverviewApp.prototype.render = function () {
        var _this = this;
        var _a;
        var menuItems = this.props.menuItems || [];
        var showAll = menuItems.length === 0;
        var showStatus = showAll || menuItems.includes("overview_status");
        var showBarPlot = showAll || menuItems.includes("overview_bar_plot");
        var showValueAtRisk = showAll || menuItems.includes("overview_value_at_risk");
        var showOwnership = showAll || menuItems.includes("overview_ownership_statistics");
        var showTags = showAll || menuItems.includes("overview_categories_and_tags");
        var showMatrices = showAll || menuItems.includes("overview_matrices");
        var showSimulation = this.props.hasSimulation && (showAll || menuItems.includes("overview_simulation"));
        var tabs = [];
        if (showStatus)
            tabs.push({ key: "status", label: gettext("Status"), isLoading: App_1.store.overview.statusTab.isLoading });
        if (showBarPlot)
            tabs.push({ key: "barplot", label: gettext("Bar Plots"), isLoading: App_1.store.overview.barplotTab.isLoading });
        if (showValueAtRisk)
            tabs.push({ key: "valueatrisk", label: gettext("Value at Risk"), isLoading: App_1.store.overview.valueatriskTab.isLoading });
        if (showOwnership)
            tabs.push({ key: "ownership", label: gettext("Ownership Statistics"), isLoading: App_1.store.overview.ownershipTab.isLoading });
        if (showTags)
            tabs.push({ key: "tags", label: gettext("Categories & Tags"), isLoading: App_1.store.overview.tagsTab.isLoading });
        if (showMatrices)
            tabs.push({ key: "matrices", label: gettext("Matrices"), isLoading: App_1.store.overview.matrixTab.isLoading });
        if (showSimulation)
            tabs.push({ key: "simulation", label: gettext("Simulation"), isLoading: App_1.store.overview.simulationTab.isLoading });
        if (tabs.length === 0) {
            return (React.createElement("div", { className: "alert alert-info" }, gettext("No overview modules are enabled.")));
        }
        var tabIndex = Math.min(this.state.tabIndex, tabs.length - 1);
        var currentTab = (_a = tabs[tabIndex]) === null || _a === void 0 ? void 0 : _a.key;
        switch (currentTab) {
            case "barplot":
                $(".filter_number, .filter_template, .matrix_mode, .include_costs, .simulation_options, .filter_values").addClass("d-none");
                $(".view_option, .filter_eval").removeClass("d-none");
                break;
            case "valueatrisk":
                $(".filter_template, .matrix_mode, .simulation_options, .filter_values").addClass("d-none");
                $(".view_option, .filter_number, .filter_eval, .include_costs").removeClass("d-none");
                break;
            case "matrices":
                $(".include_costs, .simulation_options").addClass("d-none");
                $(".view_option, .filter_number, .filter_template, .filter_eval, .matrix_mode, .filter_values").removeClass("d-none");
                break;
            case "simulation":
                $(".include_costs, .matrix_mode, .filter_number, .filter_template, .filter_values").addClass("d-none");
                $(".view_option, .filter_eval, .simulation_options").removeClass("d-none");
                break;
            default:
                $(".view_option").addClass("d-none");
        }
        return (React.createElement(react_tabs_1.Tabs, { selectedIndex: tabIndex, onSelect: function (tabIndex) { var _a; _this.setState({ tabIndex: tabIndex }); jQuery("#overviewTabIndex").val(((_a = tabs[tabIndex]) === null || _a === void 0 ? void 0 : _a.key) || ""); }, selectedTabClassName: "active" },
            React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs overviewTabs" }, tabs.map(function (tab) { return (React.createElement(react_tabs_1.Tab, { key: tab.key, className: "nav-item" },
                React.createElement("a", { className: "nav-link", href: "#0" },
                    tab.label,
                    tab.isLoading && React.createElement(exports.TabSpinner, null)))); })),
            showStatus &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(components_1.OverviewStatusListComponent, { statuses: App_1.store.overview.statusTab.statuses, todos: App_1.store.overview.statusTab.todos, isLoading: App_1.store.overview.statusTab.isLoading })),
            showBarPlot &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(components_1.OverviewBarPlotListComponent, { eval_types: App_1.store.overview.viewOptions.eval_types, data: App_1.store.overview.barplotTab.data, isLoading: App_1.store.overview.barplotTab.isLoading })),
            showValueAtRisk &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(components_1.OverviewValueAtRiskListComponent, { eval_types: App_1.store.overview.viewOptions.eval_types, number_to_show: App_1.store.overview.viewOptions.number_to_show, data: App_1.store.overview.valueatriskTab.data, isLoading: App_1.store.overview.valueatriskTab.isLoading, include_costs: App_1.store.overview.viewOptions.include_costs })),
            showOwnership &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(components_1.OverviewOwnershipListComponent, { data: App_1.store.overview.ownershipTab.data, isLoading: App_1.store.overview.ownershipTab.isLoading })),
            showTags &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(components_1.OverviewCategoriesAndTagsComponent, { data: App_1.store.overview.tagsTab.data, isLoading: App_1.store.overview.tagsTab.isLoading })),
            showMatrices &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(components_1.OverviewMatrixComponent, { eval_types: App_1.store.overview.viewOptions.eval_types, selected_definitions: App_1.store.overview.viewOptions.selected_definitions, number_to_show: App_1.store.overview.viewOptions.number_to_show, data: App_1.store.overview.matrixTab.data, isLoading: App_1.store.overview.matrixTab.isLoading, useQuantitative: App_1.store.overview.viewOptions.show_quantitative, showValues: App_1.store.overview.viewOptions.show_values })),
            showSimulation &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(simulationTab_1.OverviewSimulationComponent, { isLoading: App_1.store.overview.simulationTab.isLoading, eval_types: App_1.store.overview.viewOptions.eval_types, data: App_1.store.overview.simulationTab.data, percentiles: App_1.store.overview.viewOptions.percentiles }))));
    };
    OverviewApp = __decorate([
        mobx_react_1.observer
    ], OverviewApp);
    return OverviewApp;
}(React.Component));
exports.OverviewApp = OverviewApp;
